import React from "react";
import { Switch } from "@mui/material";
import { Account } from "@rentablo/api/apiv1";
import { AccountRow, AccountInfo } from "./components";

interface Props {
  account: Account;
  isSelected: boolean;
  onToggle: () => void;
}

export const OptionalAccountRow = ({
  account,
  isSelected,
  onToggle,
}: Props) => (
  <AccountRow>
    <AccountInfo account={account} />
    <Switch
      checked={isSelected}
      onChange={onToggle}
      size="medium"
      color="primary"
      data-testid={`optional-account-toggle-${account.id}`}
    />
  </AccountRow>
);
